<template>
	<v-app>
		<v-app-bar app color="primary" dark height="82" style="z-index: 99999">
			<div class="d-flex align-center">
				<v-img
					alt="Brand Logo"
					class="shrink mr-2"
					contain
					src="@/assets/logo.svg"
					transition="scale-transition"
					width="40"
				/>
			</div>

			<nav class="v-app__nav">
				<ul class="v-app__nav-list d-flex align-center space-x-12">
					<li
						v-for="(nav, index) in navs"
						:key="index"
						class="v-app__nav-list-item text-5"
					>
						<router-link v-if="nav.to" :to="nav.to">
							{{ nav.text }}
						</router-link>

						<v-menu v-else-if="nav.items" offset-y max-width="512">
							<template #activator="{ on, attrs }">
								<a href="javascript:void(0)" v-on="on" v-bind="attrs">
									<span>{{ nav.text }}</span>
									<v-icon>mdi-menu-down</v-icon>
								</a>
							</template>
							<v-card>
								<v-card-text>
									Lorem ipsum dolor sit, amet consectetur adipisicing
									elit. Suscipit obcaecati, et minima saepe commodi
									dignissimos explicabo quos aspernatur molestias
									quidem, provident est dolores accusamus. Sit
									voluptates nostrum eius voluptatem enim!
								</v-card-text>
							</v-card>
						</v-menu>
					</li>
				</ul>
			</nav>

			<v-spacer />

			<v-sheet class="bg-transp mr-8" width="264">
				<v-text-field
					dense
					hide-details
					prepend-icon="mdi-magnify"
					placeholder="Search"
				/>
			</v-sheet>

			<v-avatar role="button" class="bg-d5f text-1e9 text-5"> AW</v-avatar>
		</v-app-bar>

		<v-main>
			<router-view />
		</v-main>
	</v-app>
</template>

<script>
export default {
	name: 'MainLayout',
	data: () => ({
		navs: [
			{
				text: 'Invoice',
				items: [],
			},
			{
				to: '/inbox',
				text: 'Smart Inbox',
			},
			{
				to: '/docs',
				text: 'Document Management',
			},
			{
				to: '/reports',
				text: 'Reports',
			},
			{
				to: '/business',
				text: 'Business Rules',
			},
		],
	}),
}
</script>
<style lang="scss">
.v-app-bar {
	.v-toolbar {
		&__content {
			padding: 4px 27px;
		}
	}
}

.v-app {
	&__nav {
		&-list {
			list-style: none;
		}
		&-list-item {
			a {
				font-weight: normal;
				text-decoration: none;
				&,
				.v-icon {
					color: rgba(255, 255, 255, 0.7) !important;
				}
			}
			.router-link-exact-active {
				color: white !important;
				font-weight: bold !important;
			}
		}
	}
}
</style>
